'use client';

import dynamic from 'next/dynamic';
import HireProcess from '@/components/technologies/hire-process';
import ModelsOfWorking from '@/components/technologies/models-of-working';
import TechnologyFaq from '@/components/technologies/technology-faq';
import UiUxFAQ from '@/components/faqs/uiux-faq';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import UiuxServies from '@/components/technologies/uiux-demand';

import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import MetaTags from '@/components/meta-tag/meta-tag';
import Blog from '@/components/home/blog';

const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));

const TechHeroApp = dynamic(() => import('@/components/technologies/tech-hero-app'));
const ContetVideoSection = dynamic(() => import('@/components/common/content-video'));
const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHeroApp
                className=""
                desc="Delivers seamless user experiences with our UI/UX design services to boost the value of your brand. As a top UI/UX design company, we create personalized and interactive user experiences that increase customer engagement and business performance."
                alt="hero image"
                title="hero image"
                width={582}
                height={550}
                path={'uiux-hero'}
                bgPath={'hero-bg-grunge-green'}
                color="green"
                isGreen={true}
            >
                UI/UX Design Company
            </TechHeroApp>

            <DefaultBreadcrumb parentPage="Services" isParent={true} currentPage="UI/UX" />
            <ContetVideoSection title="Design User-Centric UI/UX to Provide an Impactful Experience">
                <>
                    <p className="fw-400 text-secondary fs-md">
                        User experience (UX) and user interface (UI) describe how customers engage with your web and mobile apps.
                        Modern enterprises understand that UI/UX design has a significant impact on online presence. It impacts
                        how emotionally users are connected to your digital assets and how long they stay on them.
                    </p>
                    <p className="fw-400 text-secondary fs-md">
                        Moweb Limited is a top-notch UI/UX design company providing end-to-end mobile and web design services. We
                        empower businesses by creating responsive designs that automatically adjust to different devices. Our
                        UX/UI designers create information architecture to determine accessibility, colours, icons, typography,
                        and layouts before developing websites and mobile apps.
                    </p>
                    <p className="fw-400 text-secondary fs-md  mb-0">
                        We have a dedicated team of UI and UX design experts that follow certain mobile and web design systems.
                        These systems include competitive analysis, wire framing designs, prototyping and testing, and interaction
                        design. By following these methodologies, we ensure that we meet deadlines while also aligning business
                        objectives with user requirements. Hire our UI/UX designers to get front-end and back-end development that
                        elevates your customer interactions.
                    </p>
                </>
            </ContetVideoSection>
            <UiuxServies />
            <HireProcess
                bg="bg-uiux"
                pageTitle="Elevate Your Brand's Credibility By Hiring UI/UX Designers"
                desc="To build a brand reputation, our UI and UX designers brainstorm and create high-quality and impressive user interfaces and experiences. We can help you with your project right away."
            />
            <WhyChooseUs pageTitle="Why Choose Moweb For UI/UX Design Services?" />
            <ModelsOfWorking
                title="Engagement Models To Hire The Best UI/UX Designers"
                desc="Select from different engagement models to hire UI/UX Designers for your business needs. Different types of engagements allow you to find an optimal match for your company’s specific needs; whether that means hiring expert developers, or being flexible enough to change when necessary."
            />
            <TechnologyFaq title="FAQs On UI/UX Design Services" bg="bg-uiux">
                <UiUxFAQ />
            </TechnologyFaq>
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
